import React from 'react';
import PropTypes from 'prop-types';
import {
  AutoCompleteSuggestionItem,
  Avatar,
} from '@pearsontechnology/aero-components';

import {
  RowContent,
  RowActions,
  Name,
} from '../styles';

const AccountRow = ({ data: { id, text, role, data: account } }) => (
  <AutoCompleteSuggestionItem id={id} tabIndex={0}>
    <RowContent>
      <Avatar avatar={account} size={28} />
      <Name>{text}</Name>
    </RowContent>
    <RowActions>
      { role }
    </RowActions>
  </AutoCompleteSuggestionItem>
);

AccountRow.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AccountRow;
